module.exports = "<app-loader *ngIf=\"isLoading\"></app-loader>\r\n<select\r\n  class=\"w3-select w3-block w3-border w3-round\"\r\n  [(ngModel)]=\"value\"\r\n  [disabled]=\"isDisabled\">\r\n  <option [value]=\"null\">Select BL no.</option>\r\n  <option *ngFor=\"let t of trips\" [value]=\"t.id\" [ngStyle]=\"applyPaidStyle && t.isPaid ? {'background-color': 'lightgreen'} : {}\">{{t.label}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/ztsi-trip-select/ztsi-trip-select.component.html
// module id = ./src/app/components/shared/ztsi-trip-select/ztsi-trip-select.component.html
// module chunks = main